import React from "react";
import {
  DiaryContextType,
  FloorPlanConfigType
} from "../../../../context/DiaryContext";
import {
  addFloorPlanConfigStorage,
  FloorPlanConfigDataStorageType
} from "../../../../utils/localStorage/floorPlanConfigStorage";

const enum ConfigOptions {
  displayNonTableItems = "displayNonTableItems",
  displayTableNames = "displayTableNames",
  zoomLevel = "zoomLevel"
}
type ConfigButtonListType = {
  key: ConfigOptions;
  label: string;
};
export const floorPlanConfigOptions: ConfigButtonListType[] = [
  {
    key: ConfigOptions.displayNonTableItems,
    label: "Display Walls/Non-table Items"
  },
  {
    key: ConfigOptions.displayTableNames,
    label: "Display Table/Area Names"
  }
];

type UpdateFloorPlanConfigType = {
  update: Partial<FloorPlanConfigDataStorageType>;
  floorPlanConfig: FloorPlanConfigType;
  setDiaryContext: React.Dispatch<
    React.SetStateAction<Partial<DiaryContextType>>
  >;
};
export const updateFloorPlanConfig = ({
  update,
  floorPlanConfig,
  setDiaryContext
}: UpdateFloorPlanConfigType): void => {
  const applyConfig = getFloorPlanConfigForStorage(floorPlanConfig, update);

  setDiaryContext({
    floorPlanConfig: {
      ...floorPlanConfig,
      ...applyConfig
    }
  });

  addFloorPlanConfigStorage(applyConfig);
};

const getFloorPlanConfigForStorage = (
  floorPlanConfig: FloorPlanConfigType,
  update: Partial<FloorPlanConfigDataStorageType>
): FloorPlanConfigDataStorageType => ({
  displayNonTableItems: floorPlanConfig.displayNonTableItems,
  displayTableNames: floorPlanConfig.displayTableNames,
  zoomLevel: floorPlanConfig.zoomLevel,
  ...update
});
